const nflYay = [
  [7233, "Andre Baccellia", "WR", "ARI"],
  [8122, "Bam Knight", "RB", "ARI"],
  [10955, "Chad Ryland", "K", "ARI"],
  [10231, "Elijah Higgins", "TE", "ARI"],
  [11199, "Emari Demercado", "RB", "ARI"],
  [5970, "Greg Dortch", "WR", "ARI"],
  [4451, "Isaac Whitney", "WR", "ARI"],
  [3257, "Jacoby Brissett", "QB", "ARI"],
  [4137, "James Conner", "RB", "ARI"],
  [7050, "Josiah Deguara", "TE", "ARI"],
  [11648, "Kedon Slovis", "QB", "ARI"],
  [5849, "Kyler Murray", "QB", "ARI"],
  [11628, "Marvin Harrison", "WR", "ARI"],
  [7607, "Michael Carter", "RB", "ARI"],
  [10232, "Michael Wilson", "WR", "ARI"],
  [7812, "Simi Fehoko", "WR", "ARI"],
  [7103, "Tavien Feaster", "RB", "ARI"],
  [11802, "Tejhaun Palmer", "WR", "ARI"],
  [11716, "Tip Reiman", "TE", "ARI"],
  [11381, "Travis Vokolek", "TE", "ARI"],
  [11589, "Trey Benson", "RB", "ARI"],
  [8130, "Trey McBride", "TE", "ARI"],
  [7009, "Trishton Jackson", "WR", "ARI"],
  [11921, "Xavier Weaver", "WR", "ARI"],
  [4080, "Zay Jones", "WR", "ARI"],
  [9509, "Bijan Robinson", "RB", "ATL"],
  [11186, "Carlos Washington", "RB", "ATL"],
  [11806, "Casey Washington", "WR", "ATL"],
  [7075, "Charlie Woerner", "TE", "ATL"],
  [7521, "Chris Blair", "WR", "ATL"],
  [7090, "Darnell Mooney", "WR", "ATL"],
  [6154, "David Sills", "WR", "ATL"],
  [8112, "Drake London", "WR", "ATL"],
  [11474, "Dylan Drummond", "WR", "ATL"],
  [6185, "Easton Stick", "QB", "ATL"],
  [11961, "Emory Jones", "QB", "ATL"],
  [7531, "Feleipe Franks", "TE", "ATL"],
  [4922, "Garrett Scantling", "WR", "ATL"],
  [4198, "Jamal Agnew", "WR", "ATL"],
  [12883, "Joshua Simon", "TE", "ATL"],
  [5773, "KhaDarel Hodge", "WR", "ATL"],
  [1166, "Kirk Cousins", "QB", "ATL"],
  [7553, "Kyle Pitts", "TE", "ATL"],
  [812, "Lee Smith", "TE", "ATL"],
  [12548, "Lenny Krieg", "K", "ATL"],
  [11559, "Michael Penix", "QB", "ATL"],
  [12897, "Nathan Carter", "RB", "ATL"],
  [12478, "Nick Nash", "WR", "ATL"],
  [5096, "Ray-Ray McCloud", "WR", "ATL"],
  [8227, "Teagan Quitoriano", "TE", "ATL"],
  [8132, "Tyler Allgeier", "RB", "ATL"],
  [4666, "Younghoe Koo", "K", "ATL"],
  [4683, "Aaron Bailey", "QB", "BAL"],
  [5013, "Anthony Miller", "WR", "BAL"],
  [4744, "Barrett Burns", "TE", "BAL"],
  [8127, "Charlie Kolar", "TE", "BAL"],
  [4574, "Cooper Rush", "QB", "BAL"],
  [6694, "D'Ernest Johnson", "RB", "BAL"],
  [11964, "Dayton Wade", "WR", "BAL"],
  [1426, "DeAndre Hopkins", "WR", "BAL"],
  [3198, "Derrick Henry", "RB", "BAL"],
  [11629, "Devontez Walker", "WR", "BAL"],
  [8131, "Isaiah Likely", "TE", "BAL"],
  [5995, "Justice Hill", "RB", "BAL"],
  [9511, "Keaton Mitchell", "RB", "BAL"],
  [5134, "Keith Kirkwood", "WR", "BAL"],
  [12699, "LaJohntay Wester", "WR", "BAL"],
  [4881, "Lamar Jackson", "QB", "BAL"],
  [13213, "Lucas Scott", "FB", "BAL"],
  [5012, "Mark Andrews", "TE", "BAL"],
  [4353, "Patrick Ricard", "FB", "BAL"],
  [11570, "Rasheen Ali", "RB", "BAL"],
  [7571, "Rashod Bateman", "WR", "BAL"],
  [7595, "Tylan Wallace", "WR", "BAL"],
  [7083, "Tyler Huntley", "QB", "BAL"],
  [12711, "Tyler Loop", "K", "BAL"],
  [4924, "Zach Terrell", "QB", "BAL"],
  [8799, "Zaire Mitchell-Paden", "TE", "BAL"],
  [9997, "Zay Flowers", "WR", "BAL"],
  [4082, "Curtis Samuel", "WR", "BUF"],
  [10236, "Dalton Kincaid", "TE", "BUF"],
  [5906, "Dawson Knox", "TE", "BUF"],
  [7596, "Elijah Moore", "WR", "BUF"],
  [11573, "Frank Gore", "RB", "BUF"],
  [6943, "Gabe Davis", "WR", "BUF"],
  [12658, "Jackson Hawes", "TE", "BUF"],
  [8138, "James Cook", "RB", "BUF"],
  [4984, "Josh Allen", "QB", "BUF"],
  [7670, "Joshua Palmer", "WR", "BUF"],
  [12765, "Keleki Latu", "TE", "BUF"],
  [11637, "Keon Coleman", "WR", "BUF"],
  [8134, "Khalil Shakir", "WR", "BUF"],
  [7438, "Kristian Wilkerson", "WR", "BUF"],
  [3976, "Mitchell Trubisky", "QB", "BUF"],
  [11575, "Ray Davis", "RB", "BUF"],
  [7204, "Reggie Gilliam", "RB", "BUF"],
  [8002, "Shane Buechele", "QB", "BUF"],
  [12756, "Stephen Gosnell", "WR", "BUF"],
  [6039, "Ty Johnson", "RB", "BUF"],
  [7042, "Tyler Bass", "K", "BUF"],
  [11377, "Tyrell Shavers", "WR", "BUF"],
  [11615, "Ainias Smith", "WR", "CAR"],
  [7933, "Alex Kessman", "K", "CAR"],
  [829, "Andy Dalton", "QB", "CAR"],
  [12959, "Bryce Pierre", "TE", "CAR"],
  [9228, "Bryce Young", "QB", "CAR"],
  [11157, "Brycen Tremayne", "WR", "CAR"],
  [7594, "Chuba Hubbard", "RB", "CAR"],
  [13202, "Dalevon Campbell", "WR", "CAR"],
  [4274, "David Moore", "WR", "CAR"],
  [6931, "DeeJay Dallas", "RB", "CAR"],
  [9998, "Hendon Hooker", "QB", "CAR"],
  [5955, "Hunter Renfrow", "WR", "CAR"],
  [11600, "Ja'Tavion Sanders", "TE", "CAR"],
  [13179, "Ja'seem Reed", "WR", "CAR"],
  [11646, "Jalen Coker", "WR", "CAR"],
  [8170, "James Mitchell", "TE", "CAR"],
  [12523, "Jimmy Horn", "WR", "CAR"],
  [11583, "Jonathon Brooks", "RB", "CAR"],
  [7868, "Mason Stokke", "FB", "CAR"],
  [7618, "Micah Simon", "WR", "CAR"],
  [12473, "Mitchell Evans", "TE", "CAR"],
  [7021, "Rico Dowdle", "RB", "CAR"],
  [12961, "Ryan Fitzgerald", "K", "CAR"],
  [12526, "Tetairoa McMillan", "WR", "CAR"],
  [7694, "Tommy Tremble", "TE", "CAR"],
  [12531, "Trevor Etienne", "RB", "CAR"],
  [4490, "Wyatt Houston", "TE", "CAR"],
  [11626, "Xavier Legette", "WR", "CAR"],
  [8423, "Brittain Brown", "RB", "CHI"],
  [2020, "Cairo Santos", "K", "CHI"],
  [11560, "Caleb Williams", "QB", "CHI"],
  [1737, "Case Keenum", "QB", "CHI"],
  [6826, "Cole Kmet", "TE", "CHI"],
  [12517, "Colston Loveland", "TE", "CHI"],
  [6790, "D'Andre Swift", "RB", "CHI"],
  [4983, "DJ Moore", "WR", "CHI"],
  [13080, "Deion Hankins", "RB", "CHI"],
  [6847, "Devin Duvernay", "WR", "CHI"],
  [5282, "Duplicate Player", "WR", "CHI"],
  [5008, "Durham Smythe", "TE", "CHI"],
  [4930, "Franko House", "TE", "CHI"],
  [12746, "JP Richardson", "WR", "CHI"],
  [13079, "Jahdae Walker", "WR", "CHI"],
  [12534, "Kyle Monangai", "RB", "CHI"],
  [12519, "Luther Burden", "WR", "CHI"],
  [8921, "Maurice Alexander", "WR", "CHI"],
  [5965, "Miles Boykin", "WR", "CHI"],
  [8107, "Nikola Kalinic", "TE", "CHI"],
  [6271, "Olamide Zaccheaus", "WR", "CHI"],
  [11260, "Robert Burns", "FB", "CHI"],
  [11620, "Rome Odunze", "WR", "CHI"],
  [10235, "Roschon Johnson", "RB", "CHI"],
  [5638, "Shaq Roland", "WR", "CHI"],
  [6451, "Stephen Carlson", "TE", "CHI"],
  [6465, "Thomas Ives", "WR", "CHI"],
  [6012, "Travis Homer", "RB", "CHI"],
  [11256, "Tyson Bagent", "QB", "CHI"],
  [10226, "Andrei Iosivas", "WR", "CIN"],
  [6037, "Brett Rypien", "QB", "CIN"],
  [12062, "Cam Grandy", "TE", "CIN"],
  [10228, "Charlie Jones", "WR", "CIN"],
  [9224, "Chase Brown", "RB", "CIN"],
  [6001, "Drew Sample", "TE", "CIN"],
  [11592, "Erick All", "TE", "CIN"],
  [7839, "Evan McPherson", "K", "CIN"],
  [7529, "Gary Brightwell", "RB", "CIN"],
  [11608, "Isaiah Williams", "WR", "CIN"],
  [7564, "Ja'Marr Chase", "WR", "CIN"],
  [6111, "Jake Browning", "QB", "CIN"],
  [11640, "Jermaine Burton", "WR", "CIN"],
  [6770, "Joe Burrow", "QB", "CIN"],
  [12761, "Jordan Moore", "WR", "CIN"],
  [11649, "Kendall Milton", "RB", "CIN"],
  [4993, "Mike Gesicki", "TE", "CIN"],
  [11068, "Mitchell Tinsley", "WR", "CIN"],
  [5857, "Noah Fant", "TE", "CIN"],
  [4147, "Samaje Perine", "RB", "CIN"],
  [12543, "Tahj Brooks", "RB", "CIN"],
  [5409, "Tanner Hudson", "TE", "CIN"],
  [11598, "Tanner McLachlan", "TE", "CIN"],
  [6801, "Tee Higgins", "WR", "CIN"],
  [12797, "Ahmani Marshall", "RB", "CLE"],
  [11261, "Andre Szmyt", "K", "CLE"],
  [8157, "Bailey Zappe", "QB", "CLE"],
  [7048, "Benny LeMay", "RB", "CLE"],
  [11201, "Blake Whiteheart", "TE", "CLE"],
  [12374, "Brenden Bates", "TE", "CLE"],
  [10444, "Cedric Tillman", "WR", "CLE"],
  [8118, "David Bell", "WR", "CLE"],
  [4033, "David Njoku", "TE", "CLE"],
  [2750, "DeAndre Carter", "WR", "CLE"],
  [4017, "Deshaun Watson", "QB", "CLE"],
  [12486, "Dillon Gabriel", "QB", "CLE"],
  [12469, "Dylan Sampson", "RB", "CLE"],
  [13101, "Gage Larvadain", "WR", "CLE"],
  [12506, "Harold Fannin", "TE", "CLE"],
  [12503, "Isaiah Bond", "WR", "CLE"],
  [11633, "Jamari Thrash", "WR", "CLE"],
  [8143, "Jerome Ford", "RB", "CLE"],
  [6783, "Jerry Jeudy", "WR", "CLE"],
  [19, "Joe Flacco", "QB", "CLE"],
  [8755, "Kaden Davis", "WR", "CLE"],
  [11617, "Malachi Corley", "WR", "CLE"],
  [12512, "Quinshon Judkins", "RB", "CLE"],
  [12472, "Raheim Sanders", "RB", "CLE"],
  [8089, "Sal Cannella", "TE", "CLE"],
  [12524, "Shedeur Sanders", "QB", "CLE"],
  [6144, "Trayveon Williams", "RB", "CLE"],
  [11533, "Brandon Aubrey", "K", "DAL"],
  [11593, "Brevyn Spann-Ford", "TE", "DAL"],
  [6786, "CeeDee Lamb", "WR", "DAL"],
  [3294, "Dak Prescott", "QB", "DAL"],
  [8137, "George Pickens", "WR", "DAL"],
  [11510, "Hunter Luepke", "FB", "DAL"],
  [5004, "Ito Smith", "RB", "DAL"],
  [8110, "Jake Ferguson", "TE", "DAL"],
  [11034, "Jalen Brooks", "WR", "DAL"],
  [11506, "Jalen Cropper", "WR", "DAL"],
  [8117, "Jalen Tolbert", "WR", "DAL"],
  [7588, "Javonte Williams", "RB", "DAL"],
  [12457, "Jaydon Blue", "RB", "DAL"],
  [11557, "Joe Milton", "QB", "DAL"],
  [11511, "John Stephens", "TE", "DAL"],
  [10225, "Jonathan Mingo", "WR", "DAL"],
  [8917, "KaVontae Turpin", "WR", "DAL"],
  [10871, "Luke Schoonmaker", "TE", "DAL"],
  [8800, "Malik Davis", "RB", "DAL"],
  [6151, "Miles Sanders", "RB", "DAL"],
  [12738, "Phil Mafah", "RB", "DAL"],
  [11508, "Princeton Fant", "TE", "DAL"],
  [12851, "Rivaldo Fairweather", "TE", "DAL"],
  [11783, "Ryan Flournoy", "WR", "DAL"],
  [12849, "Traeshon Holden", "WR", "DAL"],
  [5903, "Will Grier", "QB", "DAL"],
  [10863, "A.T. Perry", "WR", "DEN"],
  [8025, "Adam Prentice", "FB", "DEN"],
  [6869, "Adam Trautman", "TE", "DEN"],
  [7093, "Adrian Killins", "RB", "DEN"],
  [11563, "Bo Nix", "QB", "DEN"],
  [12735, "Caleb Lohner", "TE", "DEN"],
  [5045, "Courtland Sutton", "WR", "DEN"],
  [4066, "Evan Engram", "TE", "DEN"],
  [6806, "J.K. Dobbins", "RB", "DEN"],
  [11439, "Jaleel McLaughlin", "RB", "DEN"],
  [6136, "Jarrett Stidham", "QB", "DEN"],
  [8249, "Lucas Krull", "TE", "DEN"],
  [9494, "Marvin Mims", "WR", "DEN"],
  [8076, "Michael Bandy", "WR", "DEN"],
  [2471, "Michael Burton", "FB", "DEN"],
  [11433, "Nate Adkins", "TE", "DEN"],
  [1604, "Nick Williams", "WR", "DEN"],
  [12492, "Pat Bryant", "WR", "DEN"],
  [11245, "Patrick Murtagh", "TE", "DEN"],
  [12489, "RJ Harvey", "RB", "DEN"],
  [7583, "Sam Ehlinger", "QB", "DEN"],
  [11073, "Thayer Thomas", "WR", "DEN"],
  [5154, "Trent Sherfield", "WR", "DEN"],
  [11627, "Troy Franklin", "WR", "DEN"],
  [8208, "Tyler Badie", "RB", "DEN"],
  [3678, "Wil Lutz", "K", "DEN"],
  [7547, "Amon-Ra St. Brown", "WR", "DET"],
  [7891, "Brock Wright", "TE", "DET"],
  [6659, "Craig Reynolds", "RB", "DET"],
  [5892, "David Montgomery", "RB", "DET"],
  [12732, "Dominic Lovett", "WR", "DET"],
  [12535, "Isaac TeSlaa", "WR", "DET"],
  [12938, "Jackson Meeks", "WR", "DET"],
  [11237, "Jacob Saylors", "RB", "DET"],
  [9221, "Jahmyr Gibbs", "RB", "DET"],
  [11539, "Jake Bates", "K", "DET"],
  [8148, "Jameson Williams", "WR", "DET"],
  [3163, "Jared Goff", "QB", "DET"],
  [3634, "Kalif Raymond", "WR", "DET"],
  [7597, "Kenny Yeboah", "TE", "DET"],
  [12954, "Kye Robichaux", "RB", "DET"],
  [5127, "Kyle Allen", "QB", "DET"],
  [6992, "Michael Warren", "RB", "DET"],
  [10221, "Ronnie Bell", "WR", "DET"],
  [10859, "Sam LaPorta", "TE", "DET"],
  [8041, "Shane Zylstra", "TE", "DET"],
  [11729, "Sione Vaki", "RB", "DET"],
  [6588, "Tom Kennedy", "WR", "DET"],
  [13110, "Zach Horton", "TE", "DET"],
  [11082, "Ben Sims", "TE", "GB"],
  [8204, "Bo Melton", "WR", "GB"],
  [1433, "Brandon McManus", "K", "GB"],
  [3239, "Bronson Kaufusi", "TE", "GB"],
  [11370, "Chris Brooks", "RB", "GB"],
  [8167, "Christian Watson", "WR", "GB"],
  [10217, "Clayton Tune", "QB", "GB"],
  [6540, "DeAndre Thompkins", "WR", "GB"],
  [9486, "Dontayvion Wicks", "WR", "GB"],
  [11435, "Emanuel Wilson", "RB", "GB"],
  [5957, "Isaac Nauta", "TE", "GB"],
  [13074, "Isaiah Neyor", "WR", "GB"],
  [9227, "Israel Abanikanda", "RB", "GB"],
  [10222, "Jayden Reed", "WR", "GB"],
  [8500, "John FitzPatrick", "TE", "GB"],
  [6804, "Jordan Love", "QB", "GB"],
  [5850, "Josh Jacobs", "RB", "GB"],
  [10212, "Josh Whyle", "TE", "GB"],
  [6175, "Kerrith Whyte", "RB", "GB"],
  [9481, "Luke Musgrave", "TE", "GB"],
  [11210, "Malik Heath", "WR", "GB"],
  [8161, "Malik Willis", "QB", "GB"],
  [11581, "MarShawn Lloyd", "RB", "GB"],
  [13237, "Mark McNamee", "K", "GB"],
  [12501, "Matthew Golden", "WR", "GB"],
  [5917, "Mecole Hardman", "WR", "GB"],
  [8121, "Romeo Doubs", "WR", "GB"],
  [12482, "Savion Williams", "WR", "GB"],
  [9484, "Tucker Kraft", "TE", "GB"],
  [12788, "Will Sheppard", "WR", "GB"],
  [5121, "Braxton Berrios", "WR", "HOU"],
  [7568, "Brevin Jordan", "TE", "HOU"],
  [12171, "British Brooks", "RB", "HOU"],
  [9758, "C.J. Stroud", "QB", "HOU"],
  [11599, "Cade Stover", "TE", "HOU"],
  [4950, "Christian Kirk", "WR", "HOU"],
  [5001, "Dalton Schultz", "TE", "HOU"],
  [8129, "Dameon Pierce", "RB", "HOU"],
  [4718, "Dare Ogunbowale", "RB", "HOU"],
  [7585, "Davis Mills", "QB", "HOU"],
  [12705, "Graham Mertz", "QB", "HOU"],
  [6850, "Harrison Bryant", "TE", "HOU"],
  [6126, "Irv Smith", "TE", "HOU"],
  [6202, "Jakob Johnson", "FB", "HOU"],
  [11056, "Jared Wayne", "WR", "HOU"],
  [11588, "Jawhar Jordan", "RB", "HOU"],
  [12484, "Jayden Higgins", "WR", "HOU"],
  [12536, "Jaylin Noel", "WR", "HOU"],
  [4018, "Joe Mixon", "RB", "HOU"],
  [12848, "Josh Kelly", "WR", "HOU"],
  [5374, "Justin Watson", "WR", "HOU"],
  [3451, "Ka'imi Fairbairn", "K", "HOU"],
  [12725, "Luke Lachey", "TE", "HOU"],
  [4988, "Nick Chubb", "RB", "HOU"],
  [7569, "Nico Collins", "WR", "HOU"],
  [12880, "Silas Bolden", "WR", "HOU"],
  [9502, "Tank Dell", "WR", "HOU"],
  [12474, "Woody Marks", "RB", "HOU"],
  [10218, "Xavier Hutchinson", "WR", "HOU"],
  [11625, "Adonai Mitchell", "WR", "IND"],
  [4937, "Al Riles", "WR", "IND"],
  [8142, "Alec Pierce", "WR", "IND"],
  [11762, "Anthony Gould", "WR", "IND"],
  [9229, "Anthony Richardson", "QB", "IND"],
  [6427, "Ashton Dulin", "WR", "IND"],
  [12829, "Coleman Owen", "WR", "IND"],
  [6453, "D.J. Montgomery", "WR", "IND"],
  [12471, "DJ Giddens", "RB", "IND"],
  [5870, "Daniel Jones", "QB", "IND"],
  [8489, "Drew Ogletree", "TE", "IND"],
  [1706, "Jack Doyle", "TE", "IND"],
  [7262, "Jalen Morton", "QB", "IND"],
  [6813, "Jonathan Taylor", "RB", "IND"],
  [9500, "Josh Downs", "WR", "IND"],
  [3155, "Laquon Treadwell", "WR", "IND"],
  [13162, "Max Mang", "TE", "IND"],
  [6819, "Michael Pittman", "WR", "IND"],
  [4054, "Mo Alie-Cox", "TE", "IND"],
  [12470, "Riley Leonard", "QB", "IND"],
  [6918, "Salvon Ahmed", "RB", "IND"],
  [6964, "Sean McKeon", "TE", "IND"],
  [12185, "Spencer Shrader", "K", "IND"],
  [8207, "Tyler Goodson", "RB", "IND"],
  [9490, "Tyler Scott", "WR", "IND"],
  [12518, "Tyler Warren", "TE", "IND"],
  [12826, "Ulysses Bentley", "RB", "IND"],
  [10220, "Will Mallory", "TE", "IND"],
  [7746, "Austin Trammell", "WR", "JAX"],
  [12490, "Bhayshul Tuten", "RB", "JAX"],
  [9480, "Brenton Strange", "TE", "JAX"],
  [11631, "Brian Thomas", "WR", "JAX"],
  [11786, "Cam Little", "K", "JAX"],
  [12908, "Chandler Brayboy", "WR", "JAX"],
  [7587, "Dyami Brown", "WR", "JAX"],
  [8114, "Erik Ezukanma", "WR", "JAX"],
  [7535, "Hunter Long", "TE", "JAX"],
  [12479, "Ja'Quinden Jackson", "RB", "JAX"],
  [4314, "Johnny Mundt", "TE", "JAX"],
  [12114, "Joshua Cephus", "WR", "JAX"],
  [12544, "LeQuint Allen", "RB", "JAX"],
  [4464, "Nick Mullens", "QB", "JAX"],
  [9487, "Parker Washington", "WR", "JAX"],
  [12901, "Patrick Herbert", "TE", "JAX"],
  [7536, "Quintin Morris", "TE", "JAX"],
  [12898, "Seth Henigan", "QB", "JAX"],
  [9225, "Tank Bigsby", "RB", "JAX"],
  [4351, "Tim Patrick", "WR", "JAX"],
  [7543, "Travis Etienne", "RB", "JAX"],
  [12530, "Travis Hunter", "WR", "JAX"],
  [7523, "Trevor Lawrence", "QB", "JAX"],
  [12455, "Brashard Smith", "RB", "KC"],
  [11582, "Carson Steele", "RB", "KC"],
  [8413, "Chris Oladokun", "QB", "KC"],
  [6820, "Clyde Edwards-Helaire", "RB", "KC"],
  [4263, "Elijah McGuire", "RB", "KC"],
  [7561, "Elijah Mitchell", "RB", "KC"],
  [6011, "Gardner Minshew", "QB", "KC"],
  [4227, "Harrison Butker", "K", "KC"],
  [5848, "Hollywood Brown", "WR", "KC"],
  [8205, "Isiah Pacheco", "RB", "KC"],
  [12817, "Jake Briningstool", "TE", "KC"],
  [12505, "Jalen Royals", "WR", "KC"],
  [11595, "Jared Wiley", "TE", "KC"],
  [11311, "Jason Brownlee", "WR", "KC"],
  [13173, "Jimmy Holiday", "WR", "KC"],
  [6677, "Joe Forson", "WR", "KC"],
  [4040, "JuJu Smith-Schuster", "WR", "KC"],
  [4098, "Kareem Hunt", "RB", "KC"],
  [8221, "Keaontay Ingram", "RB", "KC"],
  [11320, "Nikko Remigio", "WR", "KC"],
  [7828, "Noah Gray", "TE", "KC"],
  [4046, "Patrick Mahomes", "QB", "KC"],
  [10229, "Rashee Rice", "WR", "KC"],
  [4602, "Robert Tonyan", "TE", "KC"],
  [1466, "Travis Kelce", "TE", "KC"],
  [13116, "Tre Watson", "TE", "KC"],
  [8188, "Tyquan Thornton", "WR", "KC"],
  [11624, "Xavier Worthy", "WR", "KC"],
  [12928, "Amar Johnson", "RB", "LAC"],
  [8259, "Cameron Dicker", "K", "LAC"],
  [12773, "DJ Uiagalelei", "QB", "LAC"],
  [10234, "Derius Davis", "WR", "LAC"],
  [8123, "Hassan Haskins", "RB", "LAC"],
  [11940, "JaQuae Jackson", "WR", "LAC"],
  [6798, "Jalen Reagor", "WR", "LAC"],
  [6797, "Justin Herbert", "QB", "LAC"],
  [6866, "KJ Hill", "WR", "LAC"],
  [12670, "KeAndre Lambert-Smith", "WR", "LAC"],
  [1479, "Keenan Allen", "WR", "LAC"],
  [11647, "Kimani Vidal", "RB", "LAC"],
  [11635, "Ladd McConkey", "WR", "LAC"],
  [12803, "Luke Grimm", "WR", "LAC"],
  [7528, "Najee Harris", "RB", "LAC"],
  [5347, "Nyheim Miller-Hines", "RB", "LAC"],
  [12507, "Omarion Hampton", "RB", "LAC"],
  [12493, "Oronde Gadsden", "TE", "LAC"],
  [9754, "Quentin Johnston", "WR", "LAC"],
  [12113, "Thomas Yassmin", "TE", "LAC"],
  [12509, "Tre' Harris", "WR", "LAC"],
  [7610, "Trey Lance", "QB", "LAC"],
  [8885, "Tucker Fisk", "TE", "LAC"],
  [5133, "Tyler Conklin", "TE", "LAC"],
  [5010, "Will Dissly", "TE", "LAC"],
  [11586, "Blake Corum", "RB", "LAR"],
  [13011, "Brennan Presley", "WR", "LAR"],
  [11644, "Cody Schrader", "RB", "LAR"],
  [6865, "Colby Parkinson", "TE", "LAR"],
  [2133, "Davante Adams", "WR", "LAR"],
  [10214, "Davis Allen", "TE", "LAR"],
  [11569, "Jarquez Hunter", "RB", "LAR"],
  [1837, "Jimmy Garoppolo", "QB", "LAR"],
  [11623, "Jordan Whittington", "WR", "LAR"],
  [11789, "Joshua Karty", "K", "LAR"],
  [12718, "Konata Mumpfield", "WR", "LAR"],
  [8150, "Kyren Williams", "RB", "LAR"],
  [13013, "Mark Redman", "TE", "LAR"],
  [421, "Matthew Stafford", "QB", "LAR"],
  [9493, "Puka Nacua", "WR", "LAR"],
  [8195, "Ronnie Rivers", "RB", "LAR"],
  [10857, "Stetson Bennett", "QB", "LAR"],
  [12487, "Terrance Ferguson", "TE", "LAR"],
  [13003, "Tru Edwards", "WR", "LAR"],
  [7562, "Tutu Atwell", "WR", "LAR"],
  [3271, "Tyler Higbee", "TE", "LAR"],
  [11168, "Xavier Smith", "WR", "LAR"],
  [10866, "Aidan O'Connell", "QB", "LV"],
  [6843, "Albert Okwuegbunam", "TE", "LV"],
  [6386, "Alex Bachman", "WR", "LV"],
  [2309, "Amari Cooper", "WR", "LV"],
  [12527, "Ashton Jeanty", "RB", "LV"],
  [11604, "Brock Bowers", "TE", "LV"],
  [12688, "Cam Miller", "QB", "LV"],
  [13122, "Carter Runyon", "TE", "LV"],
  [11963, "Chris Collier", "RB", "LV"],
  [5095, "Daniel Carlson", "K", "LV"],
  [12541, "Dont'e Thornton", "WR", "LV"],
  [11574, "Dylan Laube", "RB", "LV"],
  [1373, "Geno Smith", "QB", "LV"],
  [4995, "Ian Thomas", "TE", "LV"],
  [12483, "Jack Bech", "WR", "LV"],
  [5947, "Jakobi Meyers", "WR", "LV"],
  [3868, "Jalen Richard", "RB", "LV"],
  [3362, "Jeff Driskel", "QB", "LV"],
  [9489, "Justin Shorter", "WR", "LV"],
  [8160, "Kenny Pickett", "QB", "LV"],
  [9482, "Michael Mayer", "TE", "LV"],
  [2749, "Raheem Mostert", "RB", "LV"],
  [11257, "Shedrick Jackson", "WR", "LV"],
  [10213, "Tre Tucker", "WR", "LV"],
  [8139, "Zamir White", "RB", "LV"],
  [12865, "AJ Henning", "WR", "MIA"],
  [6109, "Alec Ingold", "FB", "MIA"],
  [5987, "Alexander Mattison", "RB", "MIA"],
  [1984, "Allen Hurns", "WR", "MIA"],
  [2505, "Darren Waller", "TE", "MIA"],
  [9226, "De'Von Achane", "RB", "MIA"],
  [7612, "Dee Eskridge", "WR", "MIA"],
  [8172, "Greg Dulcich", "TE", "MIA"],
  [12389, "Hayden Rucci", "TE", "MIA"],
  [6996, "JaMycal Hasty", "RB", "MIA"],
  [12866, "Jalin Conyers", "TE", "MIA"],
  [5119, "Jason Sanders", "K", "MIA"],
  [7526, "Jaylen Waddle", "WR", "MIA"],
  [11643, "Jaylen Wright", "RB", "MIA"],
  [5284, "Jeff Wilson", "RB", "MIA"],
  [6167, "Jordan Scarlett", "RB", "MIA"],
  [11371, "Julian Hill", "TE", "MIA"],
  [8088, "Kalif Jackson", "TE", "MIA"],
  [11610, "Malik Washington", "WR", "MIA"],
  [7496, "Nick Westbrook-Ikhine", "WR", "MIA"],
  [12495, "Ollie Gordon", "RB", "MIA"],
  [12500, "Quinn Ewers", "QB", "MIA"],
  [7922, "Riley Patterson", "K", "MIA"],
  [11821, "Tahj Washington", "WR", "MIA"],
  [8849, "Tanner Conner", "TE", "MIA"],
  [12860, "Theo Wease", "WR", "MIA"],
  [6768, "Tua Tagovailoa", "QB", "MIA"],
  [3321, "Tyreek Hill", "WR", "MIA"],
  [7538, "Zach Wilson", "QB", "MIA"],
  [4199, "Aaron Jones", "RB", "MIN"],
  [1689, "Adam Thielen", "WR", "MIN"],
  [13121, "Ben Yurosek", "TE", "MIN"],
  [12941, "Bryson Nesbit", "TE", "MIN"],
  [3832, "C.J. Ham", "FB", "MIN"],
  [3161, "Carson Wentz", "QB", "MIN"],
  [12946, "Dontae Fleming", "WR", "MIN"],
  [12700, "Gavin Bartholomew", "TE", "MIN"],
  [11565, "J.J. McCarthy", "QB", "MIN"],
  [8180, "Jalen Nailor", "WR", "MIN"],
  [11911, "Jeshaun Jones", "WR", "MIN"],
  [9756, "Jordan Addison", "WR", "MIN"],
  [8408, "Jordan Mason", "RB", "MIN"],
  [5973, "Josh Oliver", "TE", "MIN"],
  [6794, "Justin Jefferson", "WR", "MIN"],
  [11520, "Lucky Jackson", "WR", "MIN"],
  [12775, "Max Brosmer", "QB", "MIN"],
  [13075, "Myles Price", "WR", "MIN"],
  [3258, "Nick Vannett", "TE", "MIN"],
  [7601, "Rondale Moore", "WR", "MIN"],
  [5844, "T.J. Hockenson", "TE", "MIN"],
  [12496, "Tai Felton", "WR", "MIN"],
  [8013, "Tim Jones", "WR", "MIN"],
  [8230, "Ty Chandler", "RB", "MIN"],
  [11792, "Will Reichard", "K", "MIN"],
  [10861, "Xazavian Valladay", "RB", "MIN"],
  [11299, "Zavier Scott", "RB", "MIN"],
  [12713, "Andy Borregales", "K", "NE"],
  [6945, "Antonio Gibson", "RB", "NE"],
  [3202, "Austin Hooper", "TE", "NE"],
  [12983, "Brock Lampe", "FB", "NE"],
  [12984, "CJ Dippre", "TE", "NE"],
  [9501, "DeMario Douglas", "WR", "NE"],
  [10870, "Deneric Prince", "RB", "NE"],
  [11564, "Drake Maye", "QB", "NE"],
  [12542, "Efton Chism", "WR", "NE"],
  [3214, "Hunter Henry", "TE", "NE"],
  [11619, "Ja'Lynn Polk", "WR", "NE"],
  [12045, "Jack Westover", "TE", "NE"],
  [13124, "Jeremiah Webb", "WR", "NE"],
  [12383, "John Jiles", "WR", "NE"],
  [4179, "Joshua Dobbs", "QB", "NE"],
  [9504, "Kayshon Boutte", "WR", "NE"],
  [12547, "Kyle Williams", "WR", "NE"],
  [12969, "Lan Larison", "RB", "NE"],
  [4177, "Mack Hollins", "WR", "NE"],
  [2944, "Matt LaCosse", "TE", "NE"],
  [7611, "Rhamondre Stevenson", "RB", "NE"],
  [2449, "Stefon Diggs", "WR", "NE"],
  [12412, "Terrell Jennings", "RB", "NE"],
  [11292, "Tommy DeVito", "QB", "NE"],
  [12529, "TreVeyon Henderson", "RB", "NE"],
  [4035, "Alvin Kamara", "RB", "NO"],
  [1979, "Blake Bortles", "QB", "NO"],
  [11058, "Blake Grupe", "K", "NO"],
  [2197, "Brandin Cooks", "WR", "NO"],
  [11748, "Bub Means", "WR", "NO"],
  [5113, "Cedrick Wilson", "WR", "NO"],
  [11653, "Charlie Smyth", "K", "NO"],
  [8144, "Chris Olave", "WR", "NO"],
  [11834, "Devaughn Vele", "WR", "NO"],
  [12476, "Devin Neal", "RB", "NO"],
  [5744, "Eldridge Massington", "WR", "NO"],
  [5985, "Foster Moreau", "TE", "NO"],
  [13217, "Hunter Dekkers", "QB", "NO"],
  [7946, "Jack Stoll", "TE", "NO"],
  [10215, "Jake Haener", "QB", "NO"],
  [7002, "Juwan Johnson", "TE", "NO"],
  [9757, "Kendre Miller", "RB", "NO"],
  [8200, "Kevin Austin", "WR", "NO"],
  [12068, "Mason Pline", "TE", "NO"],
  [11895, "Mason Tipton", "WR", "NO"],
  [12480, "Moliki Matavao", "TE", "NO"],
  [8676, "Rashid Shaheed", "WR", "NO"],
  [11562, "Spencer Rattler", "QB", "NO"],
  [4381, "Taysom Hill", "TE", "NO"],
  [12690, "Tommy Mellott", "WR", "NO"],
  [9492, "Trey Palmer", "WR", "NO"],
  [12079, "Treyton Welch", "TE", "NO"],
  [12545, "Tyler Shough", "QB", "NO"],
  [8223, "Velus Jones", "WR", "NO"],
  [3702, "Andy Jones", "WR", "NYG"],
  [12889, "Beaux Collins", "WR", "NYG"],
  [9499, "Bryce Ford-Wheaton", "WR", "NYG"],
  [12481, "Cam Skattebo", "RB", "NYG"],
  [3048, "Chris Manhertz", "TE", "NYG"],
  [6147, "Clayton Thorson", "QB", "NYG"],
  [8225, "Daniel Bellinger", "TE", "NYG"],
  [11654, "Dante Miller", "RB", "NYG"],
  [6149, "Darius Slayton", "WR", "NYG"],
  [6130, "Devin Singletary", "RB", "NYG"],
  [10223, "Eric Gray", "RB", "NYG"],
  [503, "Graham Gano", "K", "NYG"],
  [6699, "Gunner Olszewski", "WR", "NYG"],
  [7559, "Ihmir Smith-Marsette", "WR", "NYG"],
  [9497, "Jalin Hyatt", "WR", "NYG"],
  [2306, "Jameis Winston", "QB", "NYG"],
  [12508, "Jaxson Dart", "QB", "NYG"],
  [12385, "Jude McAtamney", "K", "NYG"],
  [1642, "Levine Toilolo", "TE", "NYG"],
  [5938, "Lil'Jordan Humphrey", "WR", "NYG"],
  [11632, "Malik Nabers", "WR", "NYG"],
  [12267, "Qadir Ismail", "WR", "NYG"],
  [1234, "Russell Wilson", "QB", "NYG"],
  [4349, "Taquan Mizzell", "RB", "NYG"],
  [11597, "Theo Johnson", "TE", "NYG"],
  [12715, "Thomas Fidone", "TE", "NYG"],
  [7149, "Tommy Stevens", "TE", "NYG"],
  [11655, "Tyrone Tracy", "RB", "NYG"],
  [8126, "Wan'Dale Robinson", "WR", "NYG"],
  [5185, "Allen Lazard", "WR", "NYJ"],
  [6323, "Andrew Beck", "RB", "NYJ"],
  [12539, "Arian Smith", "WR", "NYJ"],
  [12538, "Brady Cook", "QB", "NYJ"],
  [11576, "Braelon Allen", "RB", "NYJ"],
  [7865, "Brandon Smith", "WR", "NYJ"],
  [8155, "Breece Hall", "RB", "NYJ"],
  [8146, "Garrett Wilson", "WR", "NYJ"],
  [12015, "Harrison Mevis", "K", "NYJ"],
  [8861, "Irvin Charles", "WR", "NYJ"],
  [11571, "Isaiah Davis", "RB", "NYJ"],
  [12925, "Jamaal Pritchett", "WR", "NYJ"],
  [8219, "Jelani Woods", "TE", "NYJ"],
  [8145, "Jeremy Ruckert", "TE", "NYJ"],
  [4171, "Josh Reynolds", "WR", "NYJ"],
  [3668, "Joshua Perkins", "TE", "NYJ"],
  [7591, "Justin Fields", "QB", "NYJ"],
  [7720, "Kene Nwangwu", "RB", "NYJ"],
  [13242, "Lawrance Toafili", "RB", "NYJ"],
  [12498, "Mason Taylor", "TE", "NYJ"],
  [3050, "Myles White", "WR", "NYJ"],
  [650, "Nick Folk", "K", "NYJ"],
  [12907, "Quentin Skinner", "WR", "NYJ"],
  [8583, "Stone Smartt", "TE", "NYJ"],
  [6960, "Tyler Johnson", "WR", "NYJ"],
  [827, "Tyrod Taylor", "QB", "NYJ"],
  [11306, "Xavier Gipson", "WR", "NYJ"],
  [5859, "A.J. Brown", "WR", "PHI"],
  [6828, "A.J. Dillon", "RB", "PHI"],
  [11579, "Audric Estime", "RB", "PHI"],
  [8414, "Britain Covey", "WR", "PHI"],
  [10210, "Cameron Latu", "TE", "PHI"],
  [5022, "Dallas Goedert", "TE", "PHI"],
  [13150, "Darius Cooper", "WR", "PHI"],
  [7525, "DeVonta Smith", "WR", "PHI"],
  [11304, "E.J. Jenkins", "TE", "PHI"],
  [11139, "Elijah Cooks", "WR", "PHI"],
  [8177, "Grant Calcaterra", "TE", "PHI"],
  [8119, "Jahan Dotson", "WR", "PHI"],
  [4195, "Jake Elliott", "K", "PHI"],
  [6904, "Jalen Hurts", "QB", "PHI"],
  [11645, "Javon Baker", "WR", "PHI"],
  [8147, "John Metchie", "WR", "PHI"],
  [11636, "Johnny Wilson", "WR", "PHI"],
  [12494, "Kyle McCord", "QB", "PHI"],
  [7602, "Kylen Granson", "TE", "PHI"],
  [8162, "Sam Howell", "QB", "PHI"],
  [4866, "Saquon Barkley", "RB", "PHI"],
  [9230, "Tanner McKee", "QB", "PHI"],
  [7565, "Terrace Marshall", "WR", "PHI"],
  [11577, "Will Shipley", "RB", "PHI"],
  [96, "Aaron Rodgers", "QB", "PIT"],
  [138, "Ben Roethlisberger", "QB", "PIT"],
  [7757, "Ben Skowronek", "WR", "PIT"],
  [8125, "Calvin Austin", "WR", "PIT"],
  [1945, "Chris Boswell", "K", "PIT"],
  [8181, "Connor Heyward", "TE", "PIT"],
  [5846, "DK Metcalf", "WR", "PIT"],
  [9479, "Darnell Washington", "TE", "PIT"],
  [6016, "Dax Raymond", "TE", "PIT"],
  [6074, "Donald Parham", "TE", "PIT"],
  [5845, "Dwayne Haskins", "QB", "PIT"],
  [2118, "Eric Ebron", "TE", "PIT"],
  [12975, "JJ Galbreath", "TE", "PIT"],
  [8228, "Jaylen Warren", "RB", "PIT"],
  [4144, "Jonnu Smith", "TE", "PIT"],
  [12504, "Kaleb Johnson", "RB", "PIT"],
  [12971, "Ke'Shawn Williams", "WR", "PIT"],
  [7567, "Kenneth Gainwell", "RB", "PIT"],
  [9510, "Lew Nichols", "RB", "PIT"],
  [4972, "Mason Rudolph", "QB", "PIT"],
  [4926, "Nick Schuessler", "QB", "PIT"],
  [7600, "Pat Freiermuth", "TE", "PIT"],
  [1352, "Robert Woods", "WR", "PIT"],
  [11630, "Roman Wilson", "WR", "PIT"],
  [6290, "Scotty Miller", "WR", "PIT"],
  [8206, "Skylar Thompson", "QB", "PIT"],
  [7593, "Trey Sermon", "RB", "PIT"],
  [12511, "Will Howard", "QB", "PIT"],
  [11603, "AJ Barner", "TE", "SEA"],
  [11280, "Brady Russell", "TE", "SEA"],
  [7039, "Cody White", "WR", "SEA"],
  [4039, "Cooper Kupp", "WR", "SEA"],
  [12772, "Courtney Jackson", "WR", "SEA"],
  [12462, "Damien Martinez", "RB", "SEA"],
  [8527, "Dareke Young", "WR", "SEA"],
  [5854, "Drew Lock", "QB", "SEA"],
  [12521, "Elijah Arroyo", "TE", "SEA"],
  [4189, "Eric Saubert", "TE", "SEA"],
  [12048, "George Holani", "RB", "SEA"],
  [13047, "Jacardia Wright", "RB", "SEA"],
  [10867, "Jake Bobo", "WR", "SEA"],
  [12510, "Jalen Milroe", "QB", "SEA"],
  [2747, "Jason Myers", "K", "SEA"],
  [9488, "Jaxon Smith-Njigba", "WR", "SEA"],
  [8151, "Kenneth Walker", "RB", "SEA"],
  [10216, "Kenny McIntosh", "RB", "SEA"],
  [13151, "Nick Kallerup", "TE", "SEA"],
  [12475, "Ricky White", "WR", "SEA"],
  [12656, "Robbie Ouzts", "RB", "SEA"],
  [4943, "Sam Darnold", "QB", "SEA"],
  [4936, "Skyler Howard", "QB", "SEA"],
  [12497, "Tory Horton", "WR", "SEA"],
  [13034, "Tyrone Broden", "WR", "SEA"],
  [9753, "Zach Charbonnet", "RB", "SEA"],
  [11065, "Adrian Martinez", "QB", "SF"],
  [6803, "Brandon Aiyuk", "WR", "SF"],
  [10224, "Brayden Willis", "TE", "SF"],
  [8154, "Brian Robinson", "RB", "SF"],
  [8183, "Brock Purdy", "QB", "SF"],
  [4034, "Christian McCaffrey", "RB", "SF"],
  [12491, "Corey Kiner", "RB", "SF"],
  [3286, "Demarcus Robinson", "WR", "SF"],
  [4217, "George Kittle", "TE", "SF"],
  [4914, "Glen Coffee", "RB", "SF"],
  [11651, "Isaac Guerendo", "RB", "SF"],
  [11616, "Jacob Cowing", "WR", "SF"],
  [10937, "Jake Moody", "K", "SF"],
  [8698, "Jake Tonges", "TE", "SF"],
  [7049, "Jauan Jennings", "WR", "SF"],
  [12467, "Jordan James", "RB", "SF"],
  [12634, "Jordan Watkins", "WR", "SF"],
  [12743, "Junior Bergen", "WR", "SF"],
  [12477, "Kurtis Rourke", "QB", "SF"],
  [1379, "Kyle Juszczyk", "FB", "SF"],
  [7842, "Luke Farrell", "TE", "SF"],
  [7527, "Mac Jones", "QB", "SF"],
  [5781, "Malik Turner", "WR", "SF"],
  [5086, "Marquez Valdes-Scantling", "WR", "SF"],
  [6963, "Patrick Taylor", "RB", "SF"],
  [11638, "Ricky Pearsall", "WR", "SF"],
  [3423, "Robbie Chosen", "WR", "SF"],
  [5110, "Russell Gage", "WR", "SF"],
  [8220, "Sincere McCormick", "RB", "SF"],
  [8168, "Skyy Moore", "WR", "SF"],
  [4218, "Trent Taylor", "WR", "SF"],
  [4892, "Baker Mayfield", "QB", "TB"],
  [11584, "Bucky Irving", "RB", "TB"],
  [8111, "Cade Otton", "TE", "TB"],
  [6650, "Chase McLaughlin", "K", "TB"],
  [4037, "Chris Godwin", "WR", "TB"],
  [12776, "Connor Bazelak", "QB", "TB"],
  [1592, "Darren Fells", "TE", "TB"],
  [8801, "Dennis Houston", "WR", "TB"],
  [11820, "Devin Culp", "TE", "TB"],
  [12514, "Emeka Egbuka", "WR", "TB"],
  [12792, "Garrett Greene", "QB", "TB"],
  [11618, "Jalen McMillan", "WR", "TB"],
  [12787, "Josh Williams", "RB", "TB"],
  [11994, "Kameron Johnson", "WR", "TB"],
  [8484, "Ko Kieft", "TE", "TB"],
  [1408, "Le'Veon Bell", "RB", "TB"],
  [2216, "Mike Evans", "WR", "TB"],
  [10227, "Payne Durham", "TE", "TB"],
  [8136, "Rachaad White", "RB", "TB"],
  [11421, "Ryan Miller", "WR", "TB"],
  [9506, "Sean Tucker", "RB", "TB"],
  [3200, "Sterling Shepard", "WR", "TB"],
  [11415, "Tanner Taula", "TE", "TB"],
  [2152, "Teddy Bridgewater", "QB", "TB"],
  [12485, "Tez Johnson", "WR", "TB"],
  [3357, "Brandon Allen", "QB", "TEN"],
  [11959, "Bryce Oliver", "WR", "TEN"],
  [5223, "Caleb Scott", "WR", "TEN"],
  [4981, "Calvin Ridley", "WR", "TEN"],
  [12522, "Cam Ward", "QB", "TEN"],
  [8210, "Chig Okonkwo", "TE", "TEN"],
  [12540, "Chimere Dike", "WR", "TEN"],
  [12357, "David Martin-Robinson", "TE", "TEN"],
  [5288, "Donnie Ernsberger", "TE", "TEN"],
  [13210, "Drake Dabney", "TE", "TEN"],
  [12499, "Elic Ayomanor", "WR", "TEN"],
  [12502, "Gunnar Helm", "TE", "TEN"],
  [6957, "James Proche", "WR", "TEN"],
  [6528, "Joey Slye", "K", "TEN"],
  [11378, "Jordan Mims", "RB", "TEN"],
  [8254, "Julius Chestnut", "RB", "TEN"],
  [12516, "Kalel Mullings", "RB", "TEN"],
  [7436, "Mason Kinsey", "WR", "TEN"],
  [8924, "Thomas Odukoya", "TE", "TEN"],
  [5967, "Tony Pollard", "RB", "TEN"],
  [2549, "Trevor Siemian", "QB", "TEN"],
  [8135, "Treylon Burks", "WR", "TEN"],
  [9508, "Tyjae Spears", "RB", "TEN"],
  [2374, "Tyler Lockett", "WR", "TEN"],
  [6853, "Van Jefferson", "WR", "TEN"],
  [9999, "Will Levis", "QB", "TEN"],
  [12520, "Xavier Restrepo", "WR", "TEN"],
  [4663, "Austin Ekeler", "RB", "WAS"],
  [11596, "Ben Sinnott", "TE", "WAS"],
  [3269, "Chris Moore", "WR", "WAS"],
  [10219, "Chris Rodriguez", "RB", "WAS"],
  [11942, "Colson Yankoff", "TE", "WAS"],
  [5872, "Deebo Samuel", "WR", "WAS"],
  [12515, "Donovan Edwards", "RB", "WAS"],
  [12532, "Ja'Corey Brooks", "WR", "WAS"],
  [13120, "Jacoby Jones", "WR", "WAS"],
  [12533, "Jacory Croskey-Merritt", "RB", "WAS"],
  [11566, "Jayden Daniels", "QB", "WAS"],
  [12641, "Jaylin Lane", "WR", "WAS"],
  [4219, "Jeremy McNichols", "RB", "WAS"],
  [7716, "John Bates", "TE", "WAS"],
  [260, "Josh Johnson", "QB", "WAS"],
  [7106, "Lawrence Cager", "TE", "WAS"],
  [11650, "Luke McCaffrey", "WR", "WAS"],
  [2307, "Marcus Mariota", "QB", "WAS"],
  [6083, "Matt Gay", "K", "WAS"],
  [4234, "Noah Brown", "WR", "WAS"],
  [11558, "Sam Hartman", "QB", "WAS"],
  [3333, "Temarrick Hemingway", "TE", "WAS"],
  [5927, "Terry McLaurin", "WR", "WAS"],
  [6040, "Tyree Jackson", "TE", "WAS"],
  [3309, "Wendell Smallwood", "RB", "WAS"],
  [1339, "Zach Ertz", "TE", "WAS"],
];

export default nflYay;
